import React, { Fragment } from "react";
import DataTable from "react-data-table-component";
import Proptypes from "prop-types";

const DataTableComponent = ({
  tableData,
  tableColumns,
  pagination,
  tableCustomStyles,
  selectableRows,
  onRowClicked,
  highlightOnHover,
  className,
}) => {
  const customStyles = {
    table: {
      style: {
        backgroundColor: "#F6F6F6",
      },
    },

    headRow: {
      style: {
        backgroundColor: "#F6F6F6",
        minHeight: "52px",
        fontSize: "16px",
        // fontFamily: "sfprodisplay",
        color: "#4E4E4E",
        fontWeight: "400",
        lineHeight: "24px",
        border: "none",
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    rows: {
      style: {
        color: "#4E4E4E",
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        minHeight: "62px",
        borderRadius: "12px",
        border: "1px solid #FFF",
        background:
          "linear-gradient(180deg, rgba(255, 255, 255, 0.18) 0%, rgba(255, 255, 255, 0.31) 100%)",
        boxShadow: "0px 4px 10px 0px rgba(244, 227, 229, 0.57)",
        "&:not(:last-of-type)": {
          marginBottom: "12px",
        },

        "&:not(:first-of-type)": {
          marginTop: "6px",
        },
      },
    },
    cells: {
      style: {
        justifyContent: "center",
        display: "flex",
      },
    },
    ...(tableCustomStyles && { ...tableCustomStyles }),
  };

  return (
    <Fragment>
      <DataTable
        data={tableData}
        columns={tableColumns}
        center={true}
        responsive={true}
        pagination={pagination || false}
        selectableRows={selectableRows || false}
        customStyles={customStyles}
        onRowClicked={onRowClicked}
        highlightOnHover={highlightOnHover}
        className={className || ""}
      />
    </Fragment>
  );
};

DataTableComponent.propTypes = {
  tableData: Proptypes.array,
  tableColumns: Proptypes.array,
  pagination: Proptypes.bool,
  selectableRows: Proptypes.bool,
  highlightOnHover: Proptypes.bool,
  tableCustomStyles: Proptypes.object,
  onRowClicked: Proptypes.func,
  className: Proptypes.string,
};

export default DataTableComponent;
